function MoreMenuDirective() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      closeOnClickEl: '='
    },
    template: `
<div class="more-menu dropdown" ng-class="{ open : open }">
  <button class="btn btn-link dropdown-toggle" type="button" ng-click="open = !open">
    <i class="icon ion-more"></i>
  </button>
  <ul class="dropdown-menu dropdown-menu-with-arrows pull-right">
    <ng-transclude></ng-transclude>
  </ul>
</div>
    `,
    link: (scope, element) => {
      const el = element[0];
      const dropdownEl = el.querySelectorAll('.dropdown-menu')[0];

      scope.onClick = function (e) {
        if (e.target === dropdownEl || dropdownEl.contains(e.target)) {
          scope.open = false;
        }

        if ((el === e.target || el.contains(e.target)) && el !== dropdownEl) return;

        scope.open = false;
      };

      if (scope.closeOnClickEl) {
        scope.closeOnClickEl.addEventListener('click', scope.onClick);
      } else {
        document.body.addEventListener('click', scope.onClick);
      }

      scope.$on('$destroy', () => {
        if (scope.closeOnClickEl) {
          scope.closeOnClickEl.removeEventListener('click', scope.onClick);
        } else {
          document.body.removeEventListener('click', scope.onClick);
        }
      });
    },
    controller: [
      '$scope',
      ($scope) => {
        $scope.open = false;
      }
    ]
  };
}

MoreMenuDirective.$inject = [];

export default MoreMenuDirective;



// WEBPACK FOOTER //
// ./src/directives/moreMenu.js